
<template>
	<div>
		<header>
		    <div class="header">
				<div class="head_icon_box">
					<div class="container">
						<div class="phone_box">
							<img src="../assets/images/icon/phone.png" alt="" class="icon_phone">
							<span>+86 22 84776558</span>
						</div>
						<div class="email_box">
							<img src="../assets/images/icon/email.png" alt="" class="icon_email">
							<span>HS@Hisantech.com</span>
						</div>
						<ul class="lx_icon_box">
							<li><a href="">
                            <img src="../assets/images/icon/facebook.png" alt="" srcset="" class="icon1"/>
                            <img src="../assets/images/icon/facebook1.png" alt="" srcset="" class="icon1"/>
                            </a> </li>
							<li><a href="">
                            <img src="../assets/images/icon/whatsapp.png" alt="" srcset="" class="icon2"/>
                            <img src="../assets/images/icon/whatsapp1.png" alt="" srcset="" class="icon2"/>
                            </a> </li>
							<li><a href="https://www.linkedin.com/company/hisan-tianjin-co-ltd/">
                            <img src="../assets/images/icon/in.png" alt="" srcset="" class="icon3"/>
                            <img src="../assets/images/icon/in1.png" alt="" srcset="" class="icon3"/>
                            </a> </li>
							<li><a href="">
                            <img src="../assets/images/icon/telegram-plane.png" alt="" srcset="" class="icon4"/>
                            <img src="../assets/images/icon/telegram-plane1.png" alt="" srcset="" class="icon4"/>
                            </a> </li>
							<li><a href="">
                            <img src="../assets/images/icon/skype.png" alt="" srcset="" class="icon5"/>
                            <img src="../assets/images/icon/skype1.png" alt="" srcset="" class="icon5"/>
                            </a> </li>
							<li><a href="">
                            <img src="../assets/images/icon/vk.png" alt="" srcset="" class="icon6"/>
                            <img src="../assets/images/icon/vk1.png" alt="" srcset="" class="icon6"/>
                            </a> </li>
						</ul>
					</div>
				</div>
				<div class="container_box">
					<div class="container">
						
						<div class="header_left ">
							<router-link to="/"><img src="../assets/images/header/logo1.png" alt="" class=""/></router-link>
							
							
						</div>
						<div class="header_right">
							<ul class="head_menu">
		
								<li>
									<a href="javascript:;" class="menu_title">About Us</a>
									<div class="menu_list">
										
										<div class="menu_list_con">
											<p><router-link to="/who">Who we are </router-link></p>
											<p><router-link to="/our">Our Responsibility</router-link></p>
											<p><router-link to="/why">Why Choose us</router-link></p>
										</div>
									</div>
								</li>
								<li >
									<a href="javascript:;" class="menu_title">Products</a>
									<div class="menu_list">
										<div class="menu_list_con">
                                            <p ><router-link to="/welding">Welding wire</router-link></p>
											<p ><router-link to="/cco">CCO plate</router-link></p>
                                            <p ><router-link to="/nihard">High Chromium White Cast Iron</router-link></p>
											<p ><router-link to="/wear">Wear resistant ceramics</router-link></p>
											<p ><router-link to="/detail?id=45">Overlay Wear Pipe</router-link></p>
											<p ><router-link to="/detail?id=24">AR steel plate </router-link></p>
											
											
											
										</div>
									</div>
								</li>
								
								<li>
									<a href="javascript:;" class="menu_title">Applications</a>
									<div class="menu_list t_right">
										
										<div class="menu_list_con">
											<p ><router-link to="/appliction?cid=1">Mining</router-link></p>
											<p ><router-link to="/appliction?cid=2">Cement Plant</router-link></p>
											<p ><router-link to="/appliction?cid=3">Power Plant</router-link></p>
											<p ><router-link to="appliction?cid=4">Port</router-link></p>
											<p ><router-link to="/appliction?cid=5">Steel Mill</router-link></p>
											<p ><router-link to="/appliction?cid=6">Bulk Material Handling</router-link></p>
										</div>
									</div>
								</li>
								<li>
									<router-link to="/contact" class="contant">
										<div class="Contact">
											Contact Us
											<img src="../assets/images/icon/fei.png" alt="" class="fei">
										</div>
									</router-link>
								</li>
							</ul>
										
						</div>
					</div>
				</div>
		    </div>
			
		</header>
		
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style scoped>

</style>
